import React, {Component} from 'react';
import {connect} from 'react-redux';

import DiagnosesCardsRemover from './../../components/DiagnosesCardsRemover/DiagnosesCardsRemover';
import { isAnorexiaDiagnosis } from './../../helpers/DiagnosesHelper';
import * as actionTypes from './../../store/actions/diagnosesAction';
import Loader from './../../components/Loader/Loader'

import * as productsActionTypes from './../../store/actions/productsAction';
import * as criticalCareActionTypes from './../../store/actions/criticalCareAction';

/**
 * Diagnoses container
 */
class DiagnosesCards extends Component {
  handleDiagnosisRemove = (i) => {
    const { onRemove, resetSelectedProducts, onSelectAnorexia, data } = this.props;

    // Safety check for data access
    if (!data || !data.data || !data.data[i]) {
      return;
    }

    // If removing anorexia diagnosis, deselect anorexia state
    if (data.data[i].isAnorexia) {
      onSelectAnorexia(false);
    }

    onRemove(i);
    resetSelectedProducts();
  }

  render() {
    const {data, error, pending, selected, ready, onOrder} = this.props;

    // If is pending
    if(pending || !ready) return (
        <Loader/>
    );
    // Return switcher
    return (
      <>
        {selected.length ?
          <div className='nppe2-fc-diagnoses-cards-remover__wrapper'>
            {error && <span className='nppe2-fc-diagnoses-cards-remover__error'>{error}</span>}
            {!error &&
              <DiagnosesCardsRemover
                data={data}
                selected={selected}
                onRemove={this.handleDiagnosisRemove}
                onOrder={onOrder}
              />
            }
          </div>
          :
          null
        }
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.diagnosesReducer.selected,
    error: state.diagnosesReducer.error,
    data: state.diagnosesReducer.data,
    pending: state.diagnosesReducer.pending,
    ready: state.diagnosesReducer.ready,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onRemove: (id) => dispatch({
      type: actionTypes.REMOVE,
      removed: id,
    }),
    resetSelectedProducts: () => dispatch({
      type: productsActionTypes.RESET_PRODUCTS,
    }),
    onSelectAnorexia: (val) => dispatch({
      type: criticalCareActionTypes.SELECT_ANOREXIA,
      selected: val,
    }),
    onOrder: (orderedArray) => dispatch({
      type: actionTypes.ORDER,
      orderedArray: orderedArray,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DiagnosesCards);
